import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { AccountCreationConfirmationError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: AccountCreationConfirmationError;
  confirmAccountCreation(
    data: Boundaries["confirmAccountCreation"]["request"],
  ): void;
}

function useAccountCreationConfirmation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isAccountCreationConfirmationRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isAccountCreationConfirmationRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isAccountCreationConfirmationRequestFailure,
    ),
    error: useSelector(selector.getAccountCreationConfirmationError),
    confirmAccountCreation: core.confirmAccountCreation,
  };
}

export { useAccountCreationConfirmation };
